// One-line HINT on the order's Invoices tab: '2 events to credit . 700 FCFA' + a link to the draft / the Credit notes worklist, or the "Won't issue" line with Restore. Not a form.
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import { formatMoneyExact } from '../../../utils/format';
import { Emo } from '../../../shell/EmojiIcons';
import { openAvoirDrawer } from '../../../components/Sales/avoir/OrderAvoirsSection';
import { creditHint } from './creditWorklistModel.mjs';
import { errText } from './invoicingModel.mjs';

export default function OrderCreditHint({ operationId, refreshKey = 0 }) {
  const { t, i18n } = useTranslation('invoicing');
  const [h, setH] = useState(null); const [err, setErr] = useState('');
  const load = useCallback(() => { let alive = true; Promise.resolve().then(() => api.getAvoirSources(operationId)).then(r => alive && setH(creditHint(r))).catch(() => alive && setH(null)); return () => { alive = false; }; }, [operationId]);   // model off (404) or any failure: no hint
  useEffect(() => load(), [load, refreshKey]);
  if (!h) return null;
  const restore = async () => { setErr(''); try { await api.restoreOrderCredit(operationId); load(); } catch (e) { setErr(errText(e, i18n.language)); } };
  return (
    <div className="hint" style={{ marginBottom: 8 }} data-testid="order-credit-hint" data-kind={h.kind}>
      <Emo name="info" />{' '}
      {h.kind === 'dismissed' ? <>
        <span data-testid="order-credit-wont">{t('credit_hintWont', { reason: h.dismissal.reason_text })}</span>{' '}
        <button type="button" className="btn sm" onClick={restore} data-testid="order-credit-restore">{t('restore')}</button></> : <>
        <span data-testid="order-credit-todo">{t('credit_hintTodo', { count: h.events, amount: formatMoneyExact(h.amount) })}</span>{' '}
        {h.draft ? <button type="button" className="btn sm" onClick={() => openAvoirDrawer(operationId, { draftId: (h.draft && h.draft.id) || '' })} data-testid="order-credit-draft">{t('credit_hintOpenDraft')}</button>
          : <Link className="btn sm" to="/sales/invoices/credit-notes" data-testid="order-credit-list">{t('credit_hintOpenList')}</Link>}</>}
      {err && <span className="ferr" role="alert"> {err}</span>}
    </div>
  );
}
